import { FileUser } from "lucide-react";

import { clsxMerge } from "shared/lib/helpers";
import { DataStatesWrapper } from "shared/ui/data-states-wrapper";
import CenteredSpinner from "shared/ui/spinners/centered-spinner";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { AccountDetailsSectionContainer } from "shared/ui/account-details/component-wrapper";

import { useAccountDetailsContext } from "@/modules/pipeline/account-details/context";
import { LISTS_ACCOUNT_DETAILS_SUMMARY_SECTION_ID } from "@/constants/element-ids";

export const AccountSummarySection = ({ className }: PropsWithClassNameI) => {
  const {
    accountDetailsApi,
    accountSummary: accountDetailsSummaryData,
    account,
  } = useAccountDetailsContext();

  const aiSummary = accountDetailsSummaryData?.ai_summary;

  return (
    <div className={clsxMerge("rounded-lg bg-white", className)}>
      <AccountDetailsSectionContainer
        id={LISTS_ACCOUNT_DETAILS_SUMMARY_SECTION_ID}
        title="Account summary"
      >
        <DataStatesWrapper
          viewName="account summary"
          api={accountDetailsApi}
          loading={<CenteredSpinner className="h-[140px]" />}
        >
          {aiSummary ? (
            <div className="typography-body-4">{aiSummary}</div>
          ) : (
            <div className="italic text-black/30 typography-body-4">
              No data available
            </div>
          )}

          {account?.meta?.values && account.meta.values.length > 0 && (
            <div className="mt-2 flex flex-col gap-2">
              <hr className="w-ful h-0.5 rounded-full bg-[#E5E7FF]" />
              <div className="flex flex-col gap-2">
                {account.meta.values.map((metaValue) => (
                  <div className="flex items-start gap-3">
                    <FileUser
                      size={18}
                      className="rounded bg-black/20 px-1 py-0.5"
                    />

                    <p className="w-[96%] text-black/80 typography-body-4">
                      <span className="font-medium">{metaValue?.label}:</span>{" "}
                      <span className="text-black/50">{metaValue?.value}</span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </DataStatesWrapper>
      </AccountDetailsSectionContainer>
    </div>
  );
};
